import { styled } from '@mui/material/styles';
import { Card } from '@mui/material';
import { GRADIENT_COLOR, COLOR } from '@src/styles/color';
import BackgroundGradient from '@src/assets/images/bg-gradient-package.png';
import {
  BOX_SHADOW,
  DESKTOP_BREAKPOINT,
  // MEDIUM_BREAKPOINT,
  MOBILE_BREAKPOINT,
  PACKAGE_HEIGHT_EXTRA,
  MEDIUM_BREAKPOINT_PRICING,
} from '@src/styles/config';

const StyledPackages = styled('div')`
  width: 100%;
  min-height: 100dvh;
  /* Room for the floating "find your plan" button (24px + 40px + 24px) so it never covers the last content. */
  padding-bottom: ${(props) => (props.isMobile ? 0 : '88px')};
  box-sizing: border-box;
  overflow-x: ${(props) => props.overflowX};
  @media only screen and (max-width: 1280px) {
    margin: 0;
  }
  .container-pricing {
    padding: 0px 24px;
    box-sizing: border-box;
  }
  .title-pricing-model {
    color: ${COLOR.darkBlue};
    font-weight: 700;
    margin-top: 20px;
    font-size: 32px;
    line-height: 38px;
    letter-spacing: -0.4px;
    text-align: center;
  }
  .contact-us-link {
    text-decoration: none;
  }
  .btn-contact {
    text-transform: none;
    font-weight: 700;
    color: #1e164e;
    height: 40px;
    width: 202px;
    font-size: 14px;
    margin-top: 8px;
    display: flex;
    margin-left: auto;
    margin-right: auto;
  }
  .package-duration-item {
    position: relative;

    .package-duration-label {
      color: ${COLOR.lightText};
      font-weight: 700 !important;
    }

    .package-duration-label-active {
      color: ${COLOR.darkBlue};
      font-weight: 700 !important;
    }
  }
  .divider-white {
    border-color: white;
  }
  .clarify {
    opacity: 1 !important;
    // height: 54px;
    display: flex;
    align-items: center;
    padding: 0px 0px 0px 16px;
  }

  .content {
    color: #1c1c1e;
    strong {
      color: ${COLOR.darkGray};
    }
    font-size: 14px;
    p {
      margin: 0;
    }
  }

  .icon-contents {
    display: flex;
    align-items: center;
    margin-left: -16px;
    display: block;
    margin-right: 5px;
    .dots {
      color: #1e164ea3;
      font-size: 10px;
      margin-right: 5px;
    }
  }

  .discount-year {
    display: block;
    position: absolute;
    width: 76px;
    top: 5px;
    left: ${(props) => (props.isVietNam ? '120px' : '90px')};
    padding: 8px 16px;
    border-radius: 16px;
    font-weight: 700;
    background: ${COLOR.functionYellow[64]};
    text-transform: uppercase;
    font-size: 14px;
    text-align: center;
  }

  .policy-voice {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    font-weight: 500;
    color: ${COLOR.lightText};
    margin-left: 36px;
    margin-top: 20px;
  }

  .tabs-header {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .package-type-label {
      font-weight: 700;
      font-size: 24px;
      line-height: 32px;
      letter-spacing: -0.4px;
      color: ${COLOR.black.default};
      margin-top: 40px;
      margin-bottom: 10px;
    }
  }
  .tabs-item {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .tab {
    min-width: 300px;
    background-color: ${COLOR.white};
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .tab-active {
    border: 1px solid ${COLOR.darkBlue};
    margin-bottom: -1px;
    border-bottom: none;
    color: ${COLOR.darkBlue};
  }
  .tab-inactive {
    background-color: ${COLOR.divider};
    color: ${COLOR.dark};
  }

  .duration-header {
    margin: 0px auto 40px auto;
    width: 100%;
    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      margin-bottom: ${(props) => (props.isMobile ? '12px' : '28px')};
    }

    @media only screen and (max-width: ${DESKTOP_BREAKPOINT}) {
      width: 100%;
    }

    @media only screen and (max-width: ${MEDIUM_BREAKPOINT_PRICING}) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      margin: 0px auto 40px auto;
    }

    .checkbox-button {
      color: ${COLOR.darkBlue};
      border-radius: 100%;
    }
  }
  .duration-header-mobile {
    display: flex;
    background-color: rgb(245 245 245);
    flex-direction: column;
    z-index: 100;
    padding: 0;
    opacity: 1;
    margin-bottom: 40px;
    padding-bottom: 20px;
    align-items: center;

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      margin-bottom: ${(props) => (props.isMobile ? '12px' : '28px')};
    }

    .checkbox-button {
      color: ${COLOR.darkBlue};
      border-radius: 100%;
    }
  }
  .duration-item {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
  .duration {
    min-width: 200px;
    background-color: ${COLOR.primary};
    color: ${COLOR.darkBlue};
    text-transform: none;
  }
  .duration-inactive {
    background-color: ${COLOR.divider};
    color: ${COLOR.dark};
  }
  .empty-duration {
    height: 48px;
  }

  .packages-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0px;

    .isFull {
      min-width: 1025px;
      .business-title {
        margin-top: 0px !important;
      }
    }
  }

  .packages {
    width: 100%;
    max-width: calc((318px * 4) + (20px * 3));
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    grid-gap: 16px;
    margin-bottom: 16px;
  }

  .mobile-packages {
    display: none;
    max-width: 400px;
  }

  .step-buttons {
    display: none;
    position: fixed;
    top: 70%;
    z-index: 1000;
  }

  .discount-year-mobile {
    display: none;
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .mobile-packages,
    .step-buttons {
      display: block;
    }

    .package-duration-label {
      font-size: 14px;
    }

    .discount-year {
      display: none;
    }

    .discount-year-mobile {
      display: block;
      justify-content: center;
      padding: 8px 16px;
      border-radius: 16px;
      font-weight: 700;
      background: ${COLOR.functionYellow[64]};
      width: fit-content;
      text-transform: uppercase;
      font-size: 14px;
      margin-top: 16px;
    }

    .discount-year-height {
      height: 48px;
    }

    .tab,
    .duration {
      min-width: 0px;
    }

    .packages-wrapper {
      margin: 0;
      margin-bottom: 32px;
    }
  }

  @media only screen and (max-width: 400px) {
    .mobile-packages {
      max-width: 360px;
    }
  }

  .tab-group-wrapper {
    padding: 8px;
    background-color: #1e164e0a;
    border-radius: 480px;
    box-sizing: border-box;
    /* height: 48px; */
    display: flex;
    margin: 16px auto;
    align-items: center;
    justify-content: ${(props) => {
      if (props.isMobile) return 'unset';
      return props.isMobile ? 'space-between' : 'unset';
    }};
    width: ${(props) => (props.isMobile ? '348px' : 'max-content')};
    @media only screen and (max-width: 400px) {
      width: ${(props) => props.isMobile && '340px'};

      .tabs {
        font-size: 14px !important;
      }
      .tabs-active {
        font-size: 14px !important;
      }
    }
    .tabs,
    .tabs-active {
      padding: 8px 12px;
      font-size: 16px;
      font-weight: 700;
      height: 40px;
      box-sizing: border-box;
      cursor: pointer;
      border-radius: 480px;
      display: flex;
      gap: 5px;
      align-items: center;
      justify-content: center;
      flex: ${(props) => props.isMobile && 0.5};
      white-space: nowrap;

      .save {
        background-color: #ffd60a;
        padding: 4px 8px;
        border-radius: 500px;
        font-size: 12px;
        font-weight: 500;
        color: #1e164e;
      }

      .no-save {
        width: 0px;
        height: 28px;
      }
    }

    .tabs {
      color: #1e164e7a;
    }

    .tabs-active {
      box-shadow: 0px 4px 48px 0px rgba(0, 0, 0, 0.16);
      color: ${COLOR.darkBlue};
    }

    .pr-4 {
      padding-right: 4px;
    }

    .tabs {
      background-color: transparent;
    }

    .tabs-active {
      background-color: #ffffff;
    }
  }

  .new-buy-btn-mobile-container {
    position: fixed;
    bottom: 0px;
    left: 0px;
    right: 0px;
    backdrop-filter: blur(10px);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 15%;
    max-height: 90px;
    z-index: 10;
  }

  .new-buy-btn-mobile {
    background-color: #ffd60a;
    width: 90%;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    word-wrap: break-word;
    border-radius: 20px;
  }

  .notice-ai-voice-container {
    margin-bottom: ${(props) => props.chosenPackage && '25%'};
    .notice-ai-voice {
      display: block;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: #3c3c43a3;
    }
  }
`;

const StyledNewPackageItem = styled(Card)`
  /* these 3 line below is handle when click to package in mobile */
  .list-package-content {
    padding-top: 0px;
  }
  .buy-extra-characters-button {
    height: 40px;
    margin-bottom: 16px;
    text-transform: none;
    color: ${COLOR.darkBlue};
    font-size: 14px;
    font-weight: 700;
    border-color: #3c3c4329;
    border-radius: 8px;
  }
  .free-amount-credits {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    margin-bottom: 8px;
    justify-content: space-between;
    .free-amount-credits-item {
      display: flex;
      align-items: center;
      color: ${COLOR.darkGray};
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.4px;
    }
    .info-out-line-icon {
      font-size: 14px;
      color: #1e164ea3;
    }
    .fiber-manual-record-icon {
      color: #1e164ea3;
      font-size: 10px;
      margin-right: 10px;
      margin-bottom: 1px;
    }
  }

  .purchase-amount-credits {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    margin-bottom: 8px;
    .fiber-manual-record-icon {
      color: #1e164ea3;
      font-size: 10px;
      margin-right: 10px;
      margin-bottom: 1px;
    }
  }

  .buy-extra-chars-pack-vip-button {
    background: linear-gradient(
      93.26deg,
      #ffffff -11.27%,
      #4987ff 46.65%,
      #e064e3 94.64%
    );
    border: none;
    outline: none;
    color: rgba(255, 255, 255, 1);
    transition: 0.7;
    &:hover {
      opacity: 0.7;
    }
  }
  .card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }
  .extra-characters {
    position: relative;
  }
  .discount-tag {
    width: 38px;
    position: absolute;
    top: -6px;
    right: -42px;
  }
  .box-range {
    margin-top: 32px;
  }
  .flexItem {
    display: flex;
    justify-content: space-between;
  }

  .tooltip {
    color: ${COLOR.tooltipColor};
    svg {
      width: 16px;
      height: 16px;
    }
  }
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${(props) => props.chosenPackage && '#FFFCEC'};
  border: ${(props) =>
    props.isPoppular ? '3px solid #ffd60a' : '3px solid transparent'};
  box-shadow: none;
  overflow: visible;
  padding: ${(props) => (props.isRow ? '40px 48px' : '21px 13px 13px 13px')};
  border-radius: 16px;
  .package-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    max-height: 60px;
    .MuiTypography-root {
      line-height: 1;
    }
  }

  .package-icon {
    border-radius: 9999px;
    background-color: ${COLOR.black[8]};
    width: 48px;
    height: 48px;
  }

  .package-icon-active {
    border-radius: 9999px;
    background-color: ${COLOR.primary};
    width: 48px;
    height: 48px;
  }

  .card-content {
    margin-top: ${(props) => props.isMobile && '8px'};
    position: relative;
  }

  .card-info {
    text-align: center;
  }

  .disabled-icon-content {
    color: ${COLOR.light} !important;
  }

  .icon-content {
    color: ${COLOR.primary};
  }

  .most-popular {
    background: ${GRADIENT_COLOR.orange};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .popularity {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    margin-bottom: 24px;
    background: ${COLOR.yellow[16]};
    padding: 2px;
    padding-left: 12px;
    border-radius: ${(props) => (props.isMobile ? '8px' : '0px 0px 12px 12px')};

    .popularity-text {
      font-size: 12px;
    }
  }

  .crown-icon {
    margin-right: 4px;
  }
  .name-content {
    display: flex;
    align-items: center;
    gap: 0 4px 0 0;
  }

  .package-name {
    font-size: 20px;
    font-weight: bold;
    color: ${COLOR.darkGray};
  }

  .package-name-row {
    font-size: 32px;
    font-weight: 700;
    color: ${COLOR.darkGray};
  }

  .package-name-vip {
    background: linear-gradient(95.62deg, #4987ff 1.99%, #e064e3 23.11%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .package-name-popular {
    font-size: 20px;
    font-weight: bold;
    color: #ff5a12;
  }

  .price-package-vip {
    background: linear-gradient(
      96.23deg,
      #ffffff -35.11%,
      #4987ff 35.41%,
      #e064e3 168.05%
    );
    background-clip: text;
    -webkit-text-fill-color: transparent;
    background-size: cover;
    background-position: center;
  }

  .package-limited-deal {
    font-size: 12px;
    font-weight: 500;
    color: ${COLOR.darkBlue};
    background: ${COLOR.yellow[64]};
    padding: 2px 8px;
    border-radius: 20px;
    width: fit-content;
  }

  .chip-wrapper {
    display: flex;
    top: 0;
    left: 0;
    gap: 8px;
  }

  .price-package {
    display: flex;
    align-items: center;
    letter-spacing: -1.4px;
  }

  .price-wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: ${(props) => (props.isMobile || props.isRow ? '0px' : '24px')};
  }

  .original-price-wrapper {
    display: flex;
    align-items: center;
    height: 20px;
  }
  .original-custom-price-wrapper {
    display: flex;
    align-items: center;
    height: 20px;
    gap: 6px;
  }

  .price-original-discount {
    padding-top: 2px;
    .discount-unit-price {
      font-size: 12px;
      font-weight: 400;
      line-height: 24px;
      color: ${COLOR.lightText};
      text-transform: lowercase;
      padding-bottom: -2px;
    }
  }

  .original-price,
  .original-price-not-line-through {
    font-size: 14px;
    font-weight: 400;
    line-height: 32px;
    white-space: nowrap;
    color: ${COLOR.lightText};
  }

  .original-price-not-line-through {
    text-decoration: none;
    margin-left: -6px;
  }

  .price-en {
  }

  .original-card {
    min-height: 52px;
  }

  .price {
    font-size: 24px;
    letter-spacing: 0;
    font-weight: 700;
    white-space: nowrap;
    color: ${COLOR.darkBlue};
    display: flex;
    align-items: center;
  }

  .price-highlight {
    font-size: 24px;
    font-weight: 700;
    white-space: nowrap;
    letter-spacing: 0;
    color: #ff5a12;
    display: flex;
    align-items: center;
  }

  .three-first {
    font-size: 32px;
    font-weight: 800;
  }

  .three-last {
    font-size: 16px;
    font-weight: 700;
  }

  .unit-price {
    font-weight: 510;
    font-size: 16px;
    line-height: 24px;
    color: ${COLOR.darkBlue};
    text-transform: lowercase;
    padding-bottom: -2px;
  }

  .unit-price-highlight {
    font-weight: 510;
    font-size: 16px;
    line-height: 24px;
    color: '#FF5A12';
    text-transform: lowercase;
    padding-bottom: -2px;
  }

  .unit-price-vip {
    .unit-price {
      font-weight: 510;
      font-size: 16px;
      line-height: 15px;
      color: ${COLOR.darkBlue};
      text-transform: lowercase;
      padding-bottom: -2px;
      background: linear-gradient(
        96.23deg,
        #ffffff -35.11%,
        #4987ff 35.41%,
        #e064e3 168.05%
      );
      background-clip: text;
      -webkit-text-fill-color: transparent;
      text-decoration: none;
      position: relative;
    }
    .unit-price::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background: linear-gradient(
        96.23deg,
        #ffffff -35.11%,
        #4987ff 35.41%,
        #e064e3 168.05%
      );
      background: ${(props) => !props?.isVietNam && 'none'};
      border-radius: 2px;
    }
  }

  .per-month {
    font-size: 14px;
    font-weight: 400;
    color: ${COLOR.lightText};
  }

  .sub-price {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    margin-left: 6px;
    color: ${COLOR.black[64]};
  }

  .original-price {
    font-size: 14px;
    font-weight: 700;
    white-space: nowrap;
    color: ${COLOR.lightText};
  }

  .original-price-month {
    font-size: 14px;
    white-space: nowrap;
    text-decoration: line-through;
    color: ${COLOR.lightText};
  }

  .original-price-unit {
    font-size: 12px;
    font-weight: 700;
    color: ${COLOR.lightText};
  }

  .font-size-14 {
    font-size: 14px !important;
  }

  .font-size-16 {
    font-size: 16px !important;
  }

  .underlined {
    text-decoration: underline;
  }

  .sub-origin-price {
    font-size: 14px;
    font-weight: 400;
    color: ${COLOR.lightText};
    margin-left: 4px;
  }

  .description {
  }

  .chip {
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${COLOR.darkBlue};
    color: ${COLOR.primary};
    border-radius: 6px 0px;
    padding: 0px 6px;
    height: ${PACKAGE_HEIGHT_EXTRA}px;
  }

  .chip-none {
    height: ${PACKAGE_HEIGHT_EXTRA}px;
    padding: 0px 6px;
  }

  .text-chip {
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    margin: auto;
  }

  .button-start {
    font-weight: bold;
    margin-top: ${(props) => (props.isRow ? '16px' : '24px')};
    border-radius: ${(props) =>
      props.highlight && props.isPoppular ? '12px 12px 0px 0px' : '12px'};
    opacity: ${(props) => (props.isDisableButton ? '0.5' : '1')};
    border-color: ${COLOR.darkBlue};
    color: ${COLOR.darkBlue};
    text-transform: none;
    height: 40px;
    padding: 8px 16px;
    box-sizing: border-box;
    pointer-events: ${(props) => props.isDisableButton && 'none'};
  }

  .button-slider-credits {
    margin-top: 81px !important;
  }

  .button-package-vip {
    border: 1px solid rgba(102, 154, 255, 1);
  }

  .button-highlight {
    background: ${COLOR.primary};
    color: ${COLOR.darkBlue};
    border-color: ${COLOR.primary};
  }

  .free-package-button {
    height: 78px;
  }

  .text-limited {
    margin: 6px 0px 3px 0px;
    color: ${COLOR.lightText};
  }

  .icon-contents {
    margin-left: -16px;
    margin-right: 5px;
    .dots {
      color: #1e164ea3;
      font-size: 10px;
      margin-right: 5px;
      margin-bottom: 1px;
    }
  }
  .title-text {
    color: #1c1c1e;
    font-weight: 700;
    margin-top: 14px;
    font-size: 14px;
  }
  .clarify {
    margin-bottom: 6px;
    opacity: 1 !important;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 16px;
    padding-right: 0;
    .coming-soon-text {
      width: 100% !important;
    }
    .coming-soon-text-advanced {
      color: #5856d6 !important;
      font-weight: 700;
    }
    .coming-soon-title {
      color: #1c1c1ea3;
      font-size: 14px;
      margin-left: 5px;
      font-weight: 400;
    }
    .item-package {
      width: 100%;
      display: flex;
      word-wrap: break-word;
      align-items: center;
      .content {
        color: #1c1c1e;
      }
    }
  }
  .package-content-item {
    margin-bottom: ${(props) => (props.isRow ? '0px' : '8px')};
  }

  .tooltip {
    display: flex;
    align-items: center;
  }
  .note {
    font-style: italic;
    font-size: 14px;
    color: #1c1c1ea3;
  }
  .disabled-content {
    color: ${COLOR.red};
  }

  .content {
    color: #1c1c1e;
    strong {
      color: ${COLOR.darkGray};
    }
    font-size: 14px;
    p {
      margin: 0;
    }
  }

  .content-deactivate {
    color: ${COLOR.light};
    font-size: 14px;
  }

  .btn-view-more-container {
    display: flex;
    justify-content: center;

    padding: 5px;
  }

  .show-more-btn {
    padding: 0px !important;
    margin: 10px 26px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.4px;
    background-color: transparent;
    color: ${COLOR.indigo[100]};
    text-decoration: underline;
    text-transform: none;
    min-width: 0px !important;
  }

  .new-show-more-btn {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    word-wrap: break-word;
    color: rgba(30, 22, 78, 0.64);
    text-transform: none;
    background: none;
  }
  .description-package {
    color: ${COLOR.label2['64']};
    font-weight: 400;
    font-size: 14px;
    height: 42px;
    letter-spacing: -0.4;
  }
  .voucher-gift-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${COLOR.yellow.default};
    border-radius: 8px;
    height: 28px;
    width: max-content;
    box-sizing: border-box;
    padding: 4px 8px;
    gap: 6px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: ${COLOR.black.default};

    img {
      width: 16px;
      height: 16px;
    }

    .gift-icon {
      width: 10px;
      height: 10px;
      color: ${COLOR.indigo.default};
    }

    .voucher-name {
      font-size: 10px;
      font-weight: 500;
      margin-left: 5px;
      line-height: 14px;
      letter-spacing: -0.4px;
    }
  }

  .package-free-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    gap: 40px;
    padding: 0px 24px;
    .package-free-header {
      flex: 7;
      .list-package-content {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 2px;
      }
    }
    .card-content-free {
      flex: 6;
      padding-top: 16px;
      .list-package-content-free {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 2px;
      }
    }
    .price-free-row {
      flex: 5;
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    overflow: ${(props) => (props.mostpopular ? 'hidden' : 'visible')};

    .chip-none {
      height: 0px;
    }

    .card-info {
      margin-top: 0px !important;
    }
  }
`;

const StyledPackageItem = styled(Card)`
  overflow: visible;
  padding: 20px;
  border-radius: ${(props) => (props.highlight ? '0px 0px 16px 16px' : '16px')};
  box-shadow: ${(props) =>
    props.highlight ? BOX_SHADOW : '0px 2px 16px 0px #00000014'};
  border: ${(props) =>
    props.isDiscountPackage
      ? `2px solid ${COLOR.yellow.default}`
      : `2px solid ${COLOR.white}`};

  .package-header {
    display: flex;
    justify-content: space-between;
    height: 60px;
  }

  .card-content {
    position: relative;
  }

  .card-info {
    text-align: center;
  }

  .disabled-icon-content {
    color: ${COLOR.light} !important;
  }

  .icon-content {
    color: ${COLOR.primary};
  }

  .most-popular {
    background: ${GRADIENT_COLOR.orange};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .popularity {
    margin-top: 20px;
    display: flex;
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
    background: ${COLOR.yellow[16]};
    padding: 2px;
    border-radius: 12px 12px 0px 0px;

    .popularity-text {
      font-size: 12px;
    }
  }

  .package-name {
    font-size: 20px;
    font-weight: bold;
    color: ${COLOR.darkBlue};
    line-height: 1 !important;
  }

  .package-limited-deal {
    font-size: 12px;
    font-weight: 500;
    color: ${COLOR.darkBlue};
    background: ${COLOR.yellow[64]};
    padding: 2px 8px;
    border-radius: 20px;
  }

  .chip-wrapper {
    display: flex;
    top: 0;
    left: 0;
    gap: 8px;
  }

  .price-package {
    display: flex;
    align-items: center;
  }

  .price-wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 4px;
  }

  .original-price-wrapper {
    display: flex;
    align-items: center;
    height: 20px;
  }

  .price-original-discount {
    color: ${COLOR.lightText};
    text-decoration-line: line-through;
    font-size: 20px;
    font-weight: 500;
  }

  .price-en {
  }

  .original-card {
    min-height: 52px;
  }

  .price {
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    white-space: nowrap;
    color: ${COLOR.darkBlue};
  }

  .dollar-unit-price {
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    white-space: nowrap;
    color: ${COLOR.darkV2[32]};
  }

  .unit-price {
    font-weight: 500;
    font-weight: normal !important;
    font-size: 14px;
    font-weight: bold;
    text-transform: lowercase;
  }

  .unit-price-info-voucher {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: ${COLOR.black.default};
  }

  .sub-price {
    font-weight: 500;
    font-weight: normal !important;
    font-size: 14px;
    font-weight: bold;
    margin-left: 6px;
    text-transform: lowercase;
    color: ${COLOR.dark};
  }

  .original-price {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    white-space: nowrap;
    color: ${COLOR.lightText};
  }

  .original-price-unit {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: ${COLOR.lightText};
    text-decoration: underline;
  }

  .sub-origin-price {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${COLOR.lightText};
    margin-left: 4px;
  }

  .chip {
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${COLOR.darkBlue};
    color: ${COLOR.primary};
    border-radius: 6px 0px;
    padding: 0px 6px;
    height: ${PACKAGE_HEIGHT_EXTRA}px;
  }

  .chip-none {
    height: ${PACKAGE_HEIGHT_EXTRA}px;
    padding: 0px 6px;
  }

  .text-chip {
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    margin: auto;
  }

  .button-start {
    font-weight: bold;
    margin-top: 24px;
    border-radius: ${(props) =>
      props.highlight ? '0px 0px 12px 12px' : '12px'};
    border-color: ${COLOR.lightText};
    color: ${COLOR.black.default};
    text-transform: none;
  }

  .button-highlight {
    margin-top: 0px;
    background: ${COLOR.primary};
    color: ${COLOR.darkBlue};
    border-color: ${COLOR.primary};
  }

  .free-package-button {
    height: 78px;
  }

  .text-limited {
    margin: 6px 0px 3px 0px;
    color: ${COLOR.lightText};
  }

  .icon-contents {
    margin-left: -16px;
    margin-right: 5px;
    display: flex;
  }
  .clarify {
    opacity: 1 !important;
    height: 54px;
    display: flex;
    align-items: start;
  }

  .disabled-content {
    color: ${COLOR.red};
  }

  .content {
    color: #1c1c1e;
  }

  .content-deactivate {
    color: ${COLOR.light};
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    margin-top: 0px;
    overflow: ${(props) => (props.mostpopular ? 'hidden' : 'visible')};

    .chip-none {
      height: 0px;
    }

    .card-info {
      margin-top: 0px !important;
    }
  }
`;

const StyledPackageItemWrapper = styled('div')`
  box-shadow: 0px 2px 16px 0px #ffffff14;
  width: 318px;
  background: ${(props) => props.isPoppular && '#ffd60a'};
  position: relative;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  ${({ isRow }) => isRow && `width: calc((318px * 4) + (20px * 3));`}

  .package-vip {
    background-image: url(${BackgroundGradient});
    background-size: cover;
    background-position: center;
    box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.08);
    border: 3px solid rgba(102, 154, 255, 1);
  }
  .most-popular-banner {
    position: absolute;
    top: -12px;
    background: ${COLOR.primary};
    left: 16px;
    z-index: 3;
    height: 32px;
    box-sizing: border-box;
    padding: 4px 12px;
    width: 113px;
    border-radius: 77px;
    display: flex;
    place-items: center;
    justify-content: center;
    .most-popular-text {
      color: ${COLOR.darkBlue};
      text-transform: none;
      font-size: 14px;
      font-weight: 500;
    }

    img {
      transform: translateY(-2px);
    }
  }

  .check-icon {
    display: block;
    color: #1e164e7a;
  }

  .regular-package-banner {
    height: 40px;
  }

  .countdown-banner {
    margin-top: 14px;
    height: 56px;
    background: linear-gradient(0deg, #ff0c18 0%, #ff5e00 100%);
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 16px 16px 0px 0px;
    gap: 8px;
    padding: 0 16px;
    transform: translateY(-10px);

    .time-block {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .time {
      font-size: 16px;
      font-weight: 700;
      color: white;
      transform: translateY(-5px);
    }

    .transform-up {
      transform: translateY(-13px);
    }

    .label {
      font-size: 10px;
      font-weight: 510;
      color: white;
      transform: translateY(-5px);
    }

    img {
      transform: translateY(-5px);
    }
  }
  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .most-popular-banner {
      background-size: cover;
      color: ${COLOR.darkBlue};
      font-weight: 700;
      font-size: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100px;
    }
  }
`;

const StyledCountdownTime = styled('div')`
  .countdown {
    display: flex;
    justify-content: center;
    font-weight: 700;
    font-size: 16px;
    gap: 6px;
    margin-top: 4px;
    color: ${COLOR.red};
  }

  .countdown-time {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 32px;

    .countdown-time-value {
      font-size: 20px;
      line-height: 28px;
    }
  }

  .unit-time {
    color: ${COLOR.lightText};
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-transform: lowercase;
  }
`;

const StyledCountdownBanner = styled('div')`
  .countdown-box {
    background: ${(props) => props.backgroundColor || COLOR.white};
    padding: 12px 24px 24px 24px;
    border: 2px solid ${COLOR.primary};
    border-bottom: none;
    border-radius: 16px 16px 0px 0px;
    height: 38px;
    position: relative;
  }

  .countdown-deal {
    position: absolute;
    font-size: 14px;
    font-weight: 500;
    color: ${COLOR.black};
    text-align: center;
    background: ${COLOR.background};
    padding: 8px 12px;
    border-radius: 8px;
    left: calc(50% - 50px);
    top: -20px;
  }
`;

const StyledVoucherBanner = styled('div')`
  margin-bottom: 26px;
  margin-top: -16px;

  .countdown-mobile {
    display: none;

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      display: block;
      justify-content: center;
      margin-bottom: -16px;
    }
  }

  .banner-container {
    border-radius: 16px;
    padding: 4px 12px;
    height: 80px;
    border: 2px solid ${COLOR.yellow.default};
    background: #fff9db;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .countdown {
      display: flex;

      @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
        display: none;
      }
    }

    .content {
      margin-left: 8px;
      margin-right: 20px;

      .voucher-code-mobile {
        font-size: 14px;
        font-weight: 600;
        color: ${COLOR.darkV2[80]};
        display: none;
      }
    }

    .title {
      font-weight: 700;
      font-size: 20px;
      color: ${COLOR.darkBlue};
      text-transform: uppercase;
    }

    .description {
      font-size: 14px;
      font-weight: 400;
      color: ${COLOR.darkV2[80]};
    }

    .voucher-apply {
      margin-top: 4px;
      display: flex;
      gap: 8px;
      align-items: center;

      .voucher-code {
        font-weight: 700;
        color: ${COLOR.darkV2[80]};
      }
    }

    .box-gift-icon {
      height: 80px;
    }

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      border-radius: 0px 0px 16px 16px;
      height: 120px;
      margin-top: 16px;

      .title {
        font-weight: 700;
        font-size: 20px;
        color: ${COLOR.darkBlue};
        font-size: 18px;
        margin-bottom: 2px;
      }
      .voucher-code {
        font-weight: 600;
        color: ${COLOR.darkV2[80]};
      }

      .content {
        margin-left: 8px;
        margin-right: 20px;

        .voucher-code {
          display: none;
        }

        .voucher-code-mobile {
          margin-top: 2px;
          display: flex;
          font-size: 14px;
          gap: 6px;
        }
      }
    }
  }
`;

const StyleTypeDropdown = styled('div')`
  width: 100%;
  margin-bottom: 8px;

  .MuiTypography-root {
    color: ${COLOR.darkBlue};
    font-size: 14px;

    font-weight: 700;
    line-height: 20px;
    word-wrap: break-word;
  }

  .MuiSelect-select {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    padding: 8px;
  }

  .MuiOutlinedInput-root {
    background-color: white;
  }
`;

const StyledNewPackageItemWrapper = styled('div')`
  box-shadow: 0px 2px 16px 0px #ffffff14;
  width: 318px;
  background-color: ${(props) => !props.isPoppular && COLOR.white};
  position: relative;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  ${({ isRow }) => isRow && `width: calc((318px * 4) + (20px * 3));`}
  ${({ isPoppular }) =>
    isPoppular &&
    `background-image: url('https://media-frontend.vbee.vn/images/package/special-package-bg.webp');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;`}

  .most-popular-banner {
    position: absolute;
    top: -12px;
    background: ${COLOR.primary};
    left: 16px;
    z-index: 3;
    height: 32px;
    box-sizing: border-box;
    padding: 4px 12px;
    width: 113px;
    border-radius: 77px;
    display: flex;
    place-items: center;
    justify-content: center;
    .most-popular-text {
      color: ${COLOR.darkBlue};
      text-transform: none;
      font-size: 14px;
      font-weight: 500;
    }

    img {
      transform: translateY(-2px);
    }
  }

  .check-icon {
    display: block;
    color: #1e164e7a;
  }

  .regular-package-banner {
    height: 40px;
  }

  .countdown-banner {
    margin-top: 14px;
    height: 56px;
    background: linear-gradient(0deg, #ff0c18 0%, #ff5e00 100%);
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 16px 16px 0px 0px;
    gap: 8px;
    padding: 0 16px;
    transform: translateY(-10px);

    .time-block {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .time {
      font-size: 16px;
      font-weight: 700;
      color: white;
      transform: translateY(-5px);
    }

    .transform-up {
      transform: translateY(-13px);
    }

    .label {
      font-size: 10px;
      font-weight: 510;
      color: white;
      transform: translateY(-5px);
    }

    img {
      transform: translateY(-5px);
    }
  }
  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .most-popular-banner {
      background-size: cover;
      color: ${COLOR.darkBlue};
      font-weight: 700;
      font-size: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100px;
    }
  }
`;

const StyledNewPackageItemV2 = styled(Card)`
  /* these 3 line below is handle when click to package in mobile */
  .list-package-content {
    padding: 16px 12px;
    background-color: ${COLOR.charcoalV2[80]};
    border-radius: 8px;
    gap: 8px;
    display: flex;
    flex-direction: column;
  }
  .buy-extra-characters-button {
    height: 48px;
    text-transform: none;
    color: ${COLOR.indigo.default};
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: -0.4px;
    border-color: #3c3c4329;
    border-radius: 12px;
    padding: 12px 16px;
    background-color: ${COLOR.secondary[80]};

    &.MuiButton-outlined:hover {
      opacity: 0.8;
      background-color: ${COLOR.secondary[60]};
    }
  }
  .free-amount-credits {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    justify-content: space-between;
    .free-amount-credits-item {
      display: flex;
      align-items: center;
      color: ${COLOR.darkGray};
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.4px;
    }
    .info-out-line-icon {
      font-size: 14px;
      color: #1e164ea3;
    }
    .fiber-manual-record-icon {
      color: #1e164ea3;
      font-size: 10px;
      margin-right: 10px;
      margin-bottom: 1px;
    }
  }

  .purchase-amount-credits {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    .fiber-manual-record-icon {
      color: #1e164ea3;
      font-size: 10px;
      margin-right: 10px;
      margin-bottom: 1px;
    }
  }

  .buy-extra-chars-pack-vip-button {
    background: linear-gradient(
      93.26deg,
      #ffffff -11.27%,
      #4987ff 46.65%,
      #e064e3 94.64%
    );
    border: none;
    outline: none;
    color: rgba(255, 255, 255, 1);
    transition: 0.7;
    &:hover {
      opacity: 0.7;
    }
  }
  .card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }
  .extra-characters {
    position: relative;
  }
  .discount-tag {
    width: 38px;
    position: absolute;
    top: -6px;
    right: -42px;
  }
  .box-range {
    margin-top: 32px;
  }
  .flexItem {
    display: flex;
    justify-content: space-between;
  }

  .tooltip {
    color: ${COLOR.tooltipColor};
    svg {
      width: 16px;
      height: 16px;
    }
  }

  display: flex;
  flex-direction: column;
  flex: 1;
  border: ${(props) =>
    props.isPoppular ? '0.5px solid #ffd60a' : '0.5px solid #1e164e29'};
  box-shadow: none;
  overflow: visible;
  padding: ${(props) => (props.isRow ? '40px 48px' : '20px')};
  border-radius: 24px;
  background-color: ${(props) =>
    props.isPoppular ? 'transparent' : COLOR.white};

  .credit-slider-and-package-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex-grow: 1;
    justify-content: flex-end;
  }

  .card-pacakge-main-content {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  .package-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    max-height: 60px;
    .MuiTypography-root {
      line-height: 1;
    }
  }

  .package-icon {
    border-radius: 9999px;
    background-color: ${COLOR.black[8]};
    width: 48px;
    height: 48px;
  }

  .package-icon-active {
    border-radius: 9999px;
    background-color: ${COLOR.primary};
    width: 48px;
    height: 48px;
  }

  .card-package {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .card-content {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .card-info {
    text-align: center;
  }

  .disabled-icon-content {
    color: ${COLOR.light} !important;
  }

  .icon-content {
    color: ${COLOR.primary};
  }

  .most-popular {
    background: ${GRADIENT_COLOR.orange};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .popularity {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    background: ${COLOR.yellow[16]};
    padding: 2px;
    padding-left: 12px;
    border-radius: ${(props) => (props.isMobile ? '8px' : '0px 0px 12px 12px')};

    .popularity-text {
      font-size: 12px;
    }
  }

  .crown-icon {
    margin-right: 4px;
  }
  .name-content {
    display: flex;
    align-items: center;
    gap: 0 4px 0 0;
  }

  .package-name {
    font-size: 20px;
    font-weight: bold;
    color: ${COLOR.darkGray};
  }

  .package-name-row {
    font-size: 32px;
    font-weight: 700;
    color: ${COLOR.darkGray};
  }

  .package-name-vip {
    background: linear-gradient(95.62deg, #4987ff 1.99%, #e064e3 23.11%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .package-name-popular {
    font-size: 20px;
    font-weight: bold;
    color: #ff5a12;
  }

  .package-limited-deal {
    font-size: 12px;
    font-weight: 500;
    color: ${COLOR.darkBlue};
    background: ${COLOR.yellow[64]};
    padding: 2px 8px;
    border-radius: 20px;
    width: fit-content;
  }

  .chip-wrapper {
    display: flex;
    top: 0;
    left: 0;
    gap: 8px;
  }

  .price-package {
    display: flex;
    align-items: center;
    letter-spacing: -1.4px;
  }

  .price-wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 0px;
  }

  .original-price-wrapper {
    display: flex;
    align-items: center;
    height: 20px;
  }
  .original-custom-price-wrapper {
    display: flex;
    align-items: center;
    height: 20px;
    gap: 6px;
  }

  .price-original-discount {
    .discount-unit-price {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.4px;
      color: ${COLOR.label2[64]};
      text-transform: lowercase;
      padding-bottom: -2px;
    }
  }

  .original-price,
  .original-price-not-line-through {
    font-size: 14px;
    font-weight: 400;
    line-height: 32px;
    white-space: nowrap;
    color: ${COLOR.lightText};
  }

  .original-price-not-line-through {
    text-decoration: none;
    margin-left: -6px;
  }

  .original-card {
    min-height: 52px;
  }

  .package-price-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .price {
    font-size: 32px;
    font-weight: 800;
    line-height: 32px;
    white-space: nowrap;
    color: ${COLOR.darkBlue};
    display: flex;
    align-items: center;
  }

  .three-first {
    font-size: 32px;
    font-weight: 800;
    line-height: 32px;
    letter-spacing: -0.4px;
    color: ${COLOR.label2[100]};
  }

  .three-last {
    font-size: 20px;
    font-weight: 800;
    line-height: 28px;
    letter-spacing: -0.4px;
    color: ${COLOR.label2[100]};
  }

  .unit-price {
    font-weight: 510;
    font-size: 16px;
    line-height: 24px;
    color: ${COLOR.label2[100]};
    text-transform: lowercase;
    padding-bottom: -2px;
  }

  .per-month {
    font-size: 14px;
    font-weight: 400;
    color: ${COLOR.lightText};
  }

  .sub-price {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    margin-left: 6px;
    color: ${COLOR.black[64]};
  }

  .original-price {
    font-size: 14px;
    font-weight: 400;
    white-space: nowrap;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: ${COLOR.label2[64]};
  }

  .original-price-month {
    font-size: 14px;
    white-space: nowrap;
    text-decoration: line-through;
    color: ${COLOR.lightText};
  }

  .original-price-unit {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: ${COLOR.label2[64]};
  }

  .font-size-14 {
    font-size: 14px !important;
  }

  .font-size-16 {
    font-size: 16px !important;
  }

  .underlined {
    text-decoration: underline;
  }

  .sub-origin-price {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: ${COLOR.label2[64]};
  }

  .chip {
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${COLOR.darkBlue};
    color: ${COLOR.primary};
    border-radius: 6px 0px;
    padding: 0px 6px;
    height: ${PACKAGE_HEIGHT_EXTRA}px;
  }

  .chip-none {
    height: ${PACKAGE_HEIGHT_EXTRA}px;
    padding: 0px 6px;
  }

  .text-chip {
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    margin: auto;
  }

  .buy-package-btn-container {
    min-height: 80px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: auto;
  }

  .button-start {
    font-weight: bold;
    border-radius: ${(props) =>
      props.highlight && props.isPoppular ? '12px 12px 0px 0px' : '12px'};
    opacity: ${(props) => (props.isDisableButton ? '0.5' : '1')};
    border-color: ${COLOR.indigo[16]};
    color: ${COLOR.indigo[100]};
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: -0.4px;
    text-transform: none;
    height: 48px;
    padding: 12px 16px;
    box-sizing: border-box;
    pointer-events: ${(props) => props.isDisableButton && 'none'};

    &.MuiButton-outlined:not(.button-highlight):hover {
      background: #f9fafb;
      border-color: ${COLOR.indigo[16]};
    }
  }

  .button-slider-credits {
    margin-top: 81px !important;
  }

  .button-highlight {
    background: ${COLOR.primary};
    color: ${COLOR.darkBlue};
    border-color: ${COLOR.primary};
  }

  .free-package-button {
    height: 78px;
  }

  .text-limited {
    margin: 6px 0px 3px 0px;
    color: ${COLOR.lightText};
  }

  .icon-contents {
    margin-left: -16px;
    margin-right: 5px;
    .dots {
      color: #1e164ea3;
      font-size: 10px;
      margin-right: 5px;
      margin-bottom: 1px;
    }
  }
  .title-text {
    color: #1c1c1e;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.4px;
  }
  .clarify {
    opacity: 1 !important;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 16px;
    padding-right: 0;
    .coming-soon-text {
      width: 100% !important;
    }
    .coming-soon-text-advanced {
      color: #5856d6 !important;
      font-weight: 700;
    }
    .coming-soon-title {
      color: #1c1c1ea3;
      font-size: 14px;
      margin-left: 5px;
      font-weight: 400;
    }
    .item-package {
      width: 100%;
      display: flex;
      word-wrap: break-word;
      align-items: center;
      .content {
        color: #1c1c1e;
      }
    }
  }

  .tooltip {
    display: flex;
    align-items: center;
  }
  .note {
    font-style: italic;
    font-size: 14px;
    color: #1c1c1ea3;
  }
  .disabled-content {
    color: ${COLOR.red};
  }

  .content {
    color: #1c1c1e;
    strong {
      color: ${COLOR.darkGray};
    }
    font-size: 14px;
    p {
      margin: 0;
    }
  }

  .content-deactivate {
    color: ${COLOR.light};
    font-size: 14px;
  }

  .btn-view-more-container {
    display: flex;
    justify-content: center;

    padding: 5px;
  }

  .show-more-btn {
    padding: 0px !important;
    margin: 10px 26px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.4px;
    background-color: transparent;
    color: ${COLOR.indigo[100]};
    text-decoration: underline;
    text-transform: none;
    min-width: 0px !important;
  }

  .new-show-more-btn {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    word-wrap: break-word;
    color: rgba(30, 22, 78, 0.64);
    text-transform: none;
    background: none;
  }
  .description-package {
    color: ${COLOR.label2['64']};
    font-weight: 400;
    font-size: 14px;
    height: 42px;
    letter-spacing: -0.4;
  }
  .voucher-gift-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${COLOR.yellow.default};
    border-radius: 8px;
    height: 28px;
    width: max-content;
    box-sizing: border-box;
    padding: 4px 8px;
    gap: 6px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: ${COLOR.black.default};

    img {
      width: 16px;
      height: 16px;
    }

    .gift-icon {
      width: 10px;
      height: 10px;
      color: ${COLOR.indigo.default};
    }

    .voucher-name {
      font-size: 10px;
      font-weight: 500;
      margin-left: 5px;
      line-height: 14px;
      letter-spacing: -0.4px;
    }
  }

  .package-free-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    gap: 40px;
    padding: 0px 24px;
    .package-free-header {
      flex: 7;
      .list-package-content {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 2px;
      }
    }
    .card-content-free {
      flex: 6;
      padding-top: 16px;
      .list-package-content-free {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 2px;
      }
    }
    .price-free-row {
      flex: 5;
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    overflow: ${(props) => (props.mostpopular ? 'hidden' : 'visible')};

    .chip-none {
      height: 0px;
    }

    .card-info {
      margin-top: 0px !important;
    }
  }
`;

export {
  StyledPackages,
  StyledNewPackageItem,
  StyledPackageItemWrapper,
  StyledCountdownBanner,
  StyledPackageItem,
  StyledVoucherBanner,
  StyledCountdownTime,
  StyleTypeDropdown,
  StyledNewPackageItemWrapper,
  StyledNewPackageItemV2,
};
